<template>
  <div>
    
    <div class="my-4">
 
      <!-- <b-carousel v-if="permisoVisualizador != 11"
        class="imagene"
        id="carousel-1"
        v-model="slide"
        :interval="3000"
        controls
        indicators
        background="#ababab"
        img-width="1024"
        img-height="280"
        style="text-shadow: 1px 1px 2px #333"
        @sliding-start="onSlideStart"
        @sliding-end="onSlideEnd" -->
      <!-- > -->
        <!-- Text slides with image -->
  

        <!-- Slides with custom text -->
        <!-- <b-carousel-slide img-src="https://ii.ct-stc.com/3/microsites/15AC20407F71AC25/Intro%202.png">
        
        </b-carousel-slide> -->

        <!-- Slides with image only -->
 

        <!-- Slides with img slot -->
        <!-- Note the classes .d-block and .img-fluid to prevent browser default image alignment -->
        <!-- <b-carousel-slide>
          <template #img>
            <img
              class="d-block img-fluid w-100"
              width="1024"
              height="280"
              src="@/assets/sliderman.png"
              alt="image slot"
            />
          </template>
        </b-carousel-slide> -->

        <!-- Slide with blank fluid image to maintain slide aspect ratio -->

      <!-- </b-carousel> -->
      


    </div>

   
  </div>
</template>

<script>

export default {
  name: "SolimanoextranetSeleccion",

  data() {
    return {
      slide: 0,
      sliding: null,
      idSolxPostulante:null,
      permisoVisualizador:"",

     
    };
  },

  created() {
   
   this.idSolxPostulante = localStorage.getItem("idSolxPostulante")
   this.permisoVisualizador = localStorage.getItem("idPerfil")
   console.log(this.idSolxPostulante )
  },

  mutations: {},

  mounted(){
    // this.axios
    //   .get(
    //     "Contrato/ObtenerDatosContrato/" +
    //       this.idSolxPostulante
    //   ).then(r => {
    //     console.log(r.data)
    //   })
  },


  computed: {

  },

  methods: {


    
  },
};
</script>


<style scoped>
.dispo {
  overflow-x: scroll;
  overflow-y: hidden;
}

.cursor{
  cursor: pointer;
  color: green;
}



</style>
